import { useEffect, useState } from 'react';
import { eventService } from '../services/eventService';
import { Event } from '../types/search.types';

export const useSearchEvents = (eventUIds: string) => {
  const [events, setEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const abortController = new AbortController();

    const fetchEvents = async () => {
      if (!eventUIds) {
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const data = await eventService.buscarEventos(
          eventUIds,
          abortController.signal
        );
        setEvents(data);
        setError(null);
      } catch (err: any) {
        if (err.name !== 'AbortError' && err.message !== 'canceled') {
          setError(err.message || 'Erro ao buscar eventos');
        }
      } finally {
        if (!abortController.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchEvents();

    return () => {
      abortController.abort();
    };
  }, [eventUIds]);

  return { events, loading, error };
};
